import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { Request } from 'commons/utils/request'
import * as z from 'zod'

const sch = z.object({
  batchId: z.coerce.number().int().optional(),
  bsaTrackingId: z.string().optional(),
  date: z.string().optional(),
  page: z.number().int().positive().optional(),
  size: z.number().int().positive().optional(),
  status: z.string().optional()
})

export const CTRBatchesRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `ctr-batch-list`,
    validateSearch: sch,
    loader: ({ location }) => Request.post(Request.urls.bank.bsaCTRBatchesList, location.search),
    component: lazyRouteComponent(() => import('./components/List/List')),
    pendingMinMs: 1
  })
